@import 'styles/mixins';

.container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.center {
  display: flex;
  align-items: center;
}
